import React from "react";
import { buttonStyles } from "../../stylesGenerales/buttons";

const ModalDocumentosGenerales = ({
    mostrar,
    setMostrar,
    form,
    onChange,
    handleSubmit,
    editingId
}) => {
    if (!mostrar) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "25px",
                    width: "500px",
                    maxWidth: "95%",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                    borderTop: "5px solid #219ebc"
                }}
            >
                <h3
                    style={{
                        marginBottom: "20px",
                        textAlign: "center",
                        color: "#023047"
                    }}
                >
                    {editingId
                        ? "Editar Documento General"
                        : "Nuevo Documento General"}
                </h3>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: "15px" }}>
                        <label
                            style={{
                                display: "block",
                                marginBottom: "6px",
                                fontWeight: "600",
                                color: "#023047"
                            }}
                        >
                            Nombre
                        </label>

                        <input
                            type="text"
                            name="nombrearchivo"
                            value={form.nombrearchivo}
                            onChange={onChange}
                            placeholder="Ingrese el nombre del documento"
                            style={{
                                ...buttonStyles.buscador,
                                width: "100%",
                                marginRight: 0
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                        <label
                            style={{
                                display: "block",
                                marginBottom: "6px",
                                fontWeight: "600",
                                color: "#023047"
                            }}
                        >
                            Archivo
                        </label>

                        <input
                            type="file"
                            name="archivo"
                            onChange={onChange}
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                            style={{
                                ...buttonStyles.buscador,
                                width: "100%",
                                marginRight: 0,
                                padding: "8px"
                            }}
                        />
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px"
                        }}
                    >
                        <button
                            type="button"
                            onClick={() => setMostrar(false)}
                            style={{
                                ...buttonStyles.base,
                                ...buttonStyles.editarActivo
                            }}
                        >
                            Cancelar
                        </button>

                        <button
                            type="submit"
                            style={{
                                ...buttonStyles.nuevo
                            }}
                        >
                            {editingId ? "Actualizar" : "Guardar"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalDocumentosGenerales;